import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const AuthDebug = () => {
  const { user, isAuthenticated, loading } = useAuth();
  
  const token = localStorage.getItem('authToken');
  const storedUser = localStorage.getItem('currentUser');
  
  return (
    <div className="container-fluid p-4">
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">🔍 Authentication Debug Info</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h6>Auth Context State:</h6>
              <ul className="list-unstyled">
                <li><strong>Loading:</strong> {loading ? "✅ Yes" : "❌ No"}</li>
                <li><strong>Is Authenticated:</strong> {isAuthenticated ? "✅ Yes" : "❌ No"}</li>
                <li><strong>User Object:</strong> {user ? "✅ Present" : "❌ Missing"}</li>
                {user && (
                  <>
                    <li><strong>Username:</strong> {user.username || "N/A"}</li>
                    <li><strong>Email:</strong> {user.email || "N/A"}</li>
                    <li><strong>Roles:</strong> {user.roles ? user.roles.map(r => r.name).join(", ") : "None"}</li>
                  </>
                )}
              </ul>
            </div>
            <div className="col-md-6">
              <h6>LocalStorage Data:</h6>
              <ul className="list-unstyled">
                <li><strong>Auth Token:</strong> {token ? "✅ Present" : "❌ Missing"}</li>
                {token && (
                  <li><small className="text-muted">Token: {token.substring(0, 20)}...</small></li>
                )}
                <li><strong>Stored User:</strong> {storedUser ? "✅ Present" : "❌ Missing"}</li>
                {storedUser && (
                  <li><small className="text-muted">Data: {storedUser.substring(0, 50)}...</small></li>
                )}
              </ul>
            </div>
          </div>
          
          <div className="mt-3">
            <h6>Recommended Actions:</h6>
            {!token && (
              <div className="alert alert-warning">
                <i className="fas fa-exclamation-triangle me-2"></i>
                No auth token found - please log in
              </div>
            )}
            {token && !isAuthenticated && (
              <div className="alert alert-danger">
                <i className="fas fa-times-circle me-2"></i>
                Token exists but authentication failed - token may be expired
              </div>
            )}
            {isAuthenticated && (
              <div className="alert alert-success">
                <i className="fas fa-check-circle me-2"></i>
                Authentication successful!
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthDebug;